import { useFormikContext } from 'formik';

import { classifikatorsMap, getClassificators, i18, translationGroups, trb } from '../../../../../Utilities';
import { FormField, Input, Select, ToggleButton } from 'src/shared';
import { PAYER_PAYEE_TYPES } from 'src/constants';
import { IPaymentNewValues } from '../../interfaces';
import { FieldIdentificationType } from '../FieldIdentificationType';

export const PayeeInformation = () => {
  const { values }: { values: IPaymentNewValues } = useFormikContext();

  const CISO = getClassificators()?.CISO || {};
  const countries = classifikatorsMap(CISO);

  return (
    <div>
      <FormField
        name="Payment.PayeeType"
        label={trb(i18.Labels.PayeeType)}
        floating={false}
      >
        <ToggleButton
          options={PAYER_PAYEE_TYPES.map((item) => ({
            value: item.value,
            label: trb(translationGroups.PayerPayeeTypes + item.label),
          }))}
        />
      </FormField>
      {values.Payment.PayeeType ? (
        <>
          <FieldIdentificationType
            name="Payment.PayeeIdentTypeCode"
            type={values.Payment.PayeeType}
            label="PayeeIdentificationType"
          />
          <FormField
            name="Payment.PayeeIdentTypeValue"
            label={trb(i18.Labels.PayeeIdentificationCode)}
          >
            <Input />
          </FormField>
          <FormField
            name="Payment.PayeeAddress"
            label={trb(i18.Labels.PayeeAddress)}
          >
            <Input />
          </FormField>
          <FormField
            name="Payment.PayeeCountryCode"
            label={trb(i18.Labels.PayeeCountryCode)}
          >
            <Select options={countries} />
          </FormField>
        </>
      ) : null}
    </div>
  );
};
